export default __webpack_public_path__ + "static/QueenXL-4dddb33dabcce4b2f2ca05e89d7ec3b2.svg";